import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrandingResourcesComponent } from './branding-resources.component';

const routes: Routes = [ {
    path: '',
    component: BrandingResourcesComponent 
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrandingResourcesRoutingModule { }
